import * as React from 'react'
import * as classNames from 'classnames'
import { ActionBarClass } from '@sphinx/components-styles'

export const ActionBar: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => (
  <div className={classNames(ActionBarClass.container, className)} {...props}>
    {children}
  </div>
)

export const LeftActions: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => (
  <div className={classNames(ActionBarClass.leftActions, className)} {...props}>
    {children}
  </div>
)

export const RightActions: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => (
  <div
    className={classNames(ActionBarClass.rightActions, className)}
    {...props}
  >
    {children}
  </div>
)
